export default __webpack_public_path__ + "static/media/ApplePay.67bc2a74.svg";